import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function ContentSections() {
  const { t } = useTranslation();

  return (
    <>
      <section className="w-full py-10 md:py-14 px-4 md:px-6 bg-background-100">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-4 md:mb-5 font-heading text-center">
            {t('what_is_title')}
          </h2>
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed max-w-3xl mx-auto text-center">
            {t('what_is_content')}
          </p>
        </div>
      </section>

      <section className="w-full py-10 md:py-14 px-4 md:px-6 bg-background-50">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-8 md:mb-10 font-heading text-center">
            {t('how_it_works_title')}
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {[1, 2, 3, 4].map((step) => (
              <div key={step} className="text-center bg-background-50 border border-background-200/70 rounded-lg p-5 md:p-6">
                <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-accent-100 flex items-center justify-center">
                  <span className="text-lg font-bold text-accent-600 font-heading">0{step}</span>
                </div>
                <h3 className="text-base md:text-lg font-semibold text-foreground-900 mb-2 font-heading">
                  {t(`step${step}_title`)}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                  {t(`step${step}_desc`)}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="w-full py-10 md:py-14 px-4 md:px-6 bg-background-100">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-6 md:mb-8 font-heading text-center">
            {t('comparison_title')}
          </h2>
          <div className="overflow-x-auto">
            <table className="w-full border-collapse text-sm">
              <thead>
                <tr className="border-b border-background-300/60">
                  <th className="text-left py-3 px-4 text-foreground-700 font-semibold">{t('comparison_feature')}</th>
                  <th className="text-center py-3 px-4 text-accent-600 font-semibold">{t('comparison_col1')}</th>
                  <th className="text-center py-3 px-4 text-foreground-500 font-semibold">{t('comparison_col2')}</th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-b border-background-200/70">
                  <td className="py-3 px-4 text-foreground-800">{t('comparison_links')}</td>
                  <td className="text-center py-3 px-4 text-accent-500 font-bold">✓</td>
                  <td className="text-center py-3 px-4 text-foreground-400">✗</td>
                </tr>
                <tr className="border-b border-background-200/70">
                  <td className="py-3 px-4 text-foreground-800">{t('comparison_categories')}</td>
                  <td className="text-center py-3 px-4 text-accent-500 font-bold">✓</td>
                  <td className="text-center py-3 px-4 text-foreground-400">✗</td>
                </tr>
                <tr className="border-b border-background-200/70">
                  <td className="py-3 px-4 text-foreground-800">{t('comparison_time')}</td>
                  <td className="text-center py-3 px-4 text-accent-500 font-bold">★★★★★</td>
                  <td className="text-center py-3 px-4 text-foreground-400">★★</td>
                </tr>
                <tr>
                  <td className="py-3 px-4 text-foreground-800">{t('comparison_beginners')}</td>
                  <td className="text-center py-3 px-4 text-accent-500 font-bold">✓</td>
                  <td className="text-center py-3 px-4 text-foreground-400">✗</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>

      <section className="w-full py-10 md:py-14 px-4 md:px-6 bg-background-50">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-4 md:mb-5 font-heading text-center">
            {t('safety_title')}
          </h2>
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed max-w-3xl mx-auto text-center mb-6 md:mb-8">
            {t('safety_content')}
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4">
            {[1, 2, 3, 4].map((tip) => (
              <div key={tip} className="flex items-start gap-3 bg-background-100 border border-background-200/70 rounded-lg p-4">
                <div className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-shield-check-line w-4 h-4 flex items-center justify-center text-accent-600"></i>
                </div>
                <span className="text-sm text-foreground-800">{t(`safety_tip${tip}`)}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="w-full py-8 md:py-10 px-4 md:px-6 bg-accent-500">
        <div className="max-w-3xl mx-auto text-center">
          <Link
            to="/artykul/kakobuy-spreadsheet-kompletny-przewodnik"
            className="whitespace-nowrap cursor-pointer inline-flex items-center gap-2 bg-white/95 hover:bg-white text-accent-700 font-semibold px-6 py-3 rounded-full text-sm md:text-base transition-all duration-200 hover:scale-105"
          >
            <i className="ri-article-line w-5 h-5 flex items-center justify-center"></i>
            {t('article_link')}
          </Link>
        </div>
      </section>
    </>
  );
}